export default "__VITE_ASSET__ae94291b__"